import { useState } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/TradeAuthContext";
import { Mic } from "lucide-react";
import { toast } from "sonner";
import AudioRecordModal from "@/pages/trade/AudioRecordModal";

// Contact voice note: start recording, optionally call, then stop and save last.
const ContactAudioRecordButton = ({ phone, name, className = "", testid }) => {
  const { API, authHeader } = useAuth();
  const [recorderOpen, setRecorderOpen] = useState(false);

  const saveAudio = async (file, recordingName) => {
    const ext = (file.name.split(".").pop() || "webm").split(";")[0];
    const safeName = (recordingName || `${name} audio note`).replace(/[\\/:*?"<>|]/g, "-");
    const uploadFile = new File([file], `${safeName}.${ext}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("doc_type", "audio_note");
    formData.append("description", `Audio note for ${name}${phone ? ` (${phone})` : ""}`);
    formData.append("category", "misc");
    formData.append("shipment_id", "");
    try {
      await axios.post(`${API}/trade/documents/upload`, formData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" }
      });
      setRecorderOpen(false);
      toast.success("Audio saved in Documents → Miscellaneous");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save the audio note");
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setRecorderOpen(true); }}
        className={className}
        data-testid={testid}
      >
        <Mic size={12} /> Audio
      </button>
      {recorderOpen && (
        <AudioRecordModal
          onClose={() => setRecorderOpen(false)}
          onSave={saveAudio}
          saveLabel="Save to Documents"
          callPhone={phone}
          callName={name}
        />
      )}
    </>
  );
};

export default ContactAudioRecordButton;
